<script setup>
import { onMounted, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: String,
        default: 'list',
        validator: (v) => ['list', 'compact', 'grid'].includes(v),
    },
});

const emit = defineEmits(['update:modelValue']);

const modes = [
    { value: 'list', label: 'Liste', icon: '☰' },
    { value: 'compact', label: 'Kompakt', icon: '☰' },
    { value: 'grid', label: 'Grid', icon: '▦' },
];

function setMode(mode) {
    emit('update:modelValue', mode);
    if (typeof window !== 'undefined') {
        localStorage.setItem('pc-view-mode', mode);
    }
}

onMounted(() => {
    if (typeof window !== 'undefined') {
        const stored = localStorage.getItem('pc-view-mode');
        if (stored && ['list', 'compact', 'grid'].includes(stored) && !props.modelValue) {
            emit('update:modelValue', stored);
        }
    }
});

watch(() => props.modelValue, (val) => {
    if (typeof window !== 'undefined' && val) {
        localStorage.setItem('pc-view-mode', val);
    }
});
</script>

<template>
    <div class="view-mode-toggle">
        <button
            v-for="mode in modes"
            :key="mode.value"
            :class="['toggle-btn', { active: modelValue === mode.value }]"
            :aria-label="mode.label"
            :title="mode.label"
            @click="setMode(mode.value)"
        >
            <span class="toggle-icon" :class="{ 'icon-compact': mode.value === 'compact' }">{{ mode.icon }}</span>
            <span class="toggle-label">{{ mode.label }}</span>
        </button>
    </div>
</template>

<style scoped>
.view-mode-toggle {
    display: flex;
    gap: 4px;
    background: var(--pc-bg-secondary, #1a1a2e);
    border: 1px solid var(--pc-border, #2a2a4a);
    border-radius: var(--pc-radius, 8px);
    padding: 3px;
}

.toggle-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: none;
    border-radius: calc(var(--pc-radius, 8px) - 2px);
    background: transparent;
    color: var(--pc-text-secondary, #8888aa);
    font-size: var(--pc-text-sm, 13px);
    cursor: pointer;
    transition: all var(--pc-transition, 150ms) ease;
    white-space: nowrap;
}

.toggle-btn:hover {
    color: var(--pc-text-primary, #e0e0ff);
    background: var(--pc-bg-hover, rgba(255, 255, 255, 0.05));
}

.toggle-btn.active {
    color: var(--pc-accent, #6366f1);
    background: rgba(99, 102, 241, 0.12);
    box-shadow: 0 0 8px rgba(99, 102, 241, 0.2);
}

.toggle-icon {
    font-size: 16px;
    line-height: 1;
}

.toggle-icon.icon-compact {
    font-size: 12px;
}

.toggle-label {
    font-weight: 500;
}
</style>
